import styles from './styles.module.css';

export const SnackBar = (props) => (
    <div className={styles.message}>
        <span>{props.children}</span>
    </div>
);

export default SnackBar;
